export const validateRegex = (text, regex) => regex.test(text);
export const phoneValidator = (phone) => {
	// Valid if matches regex or is a value with length 10
	return validateRegex(phone, /[(][0-9]{3}[)] [0-9]{3}[-][0-9]{4}/g) || (phone && phone.length === 10);
};
export const numberOrEmptyValidator = (number) => validateRegex(number || '', /^[0-9]*$/g);
export const zipValidator = (zip) => validateRegex(zip, /[0-9]{5}/g);
export const escapeRegExp = (string = '') => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
export const emailValidator = (email) => validateRegex(email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/);

const auctionAccessIdRegex = /(^1\d{8}$)|(^5\d{6}$)|^$/;
export const auctionAccessIdValidator = (auctionAccessId) => validateRegex(auctionAccessId || '', auctionAccessIdRegex);
